// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vhallPlayer-progess-point-time {\n  display: block;\n  position: absolute;\n  top: -20px;\n  font-size: 12px;\n  line-height: 16.8px;\n  pointer-events: none;\n  color: #eee;\n  background-color: #333;\n}\n\n.vhallPlayer-progess-point-time.hide {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
